import React from 'react';
import ChangeWithdrawalPlanSummary from 'widgets/ChangeWithdrawal/ChangeWithdrawalPlanSummary';

const ChangeWithdrawalPlanSummaryPage = ({ datasource }: {datasource: any}) => <ChangeWithdrawalPlanSummary datasource={datasource} />;

export default ChangeWithdrawalPlanSummaryPage;
